module.exports = __webpack_public_path__ + "img/3a.d422beeb.png";